import React from "react";
import { Edit, SimpleForm, TextField, TextInput } from "react-admin";

const SchoolEdit = (props) => {
  return (
    <Edit undoable={false} {...props}>
      <SimpleForm>
        <TextField source="id" />
        <TextInput label="Name" source="name" />
        <TextInput label="Slug" source="slug" />
        <TextInput label="Abbreviation" source="abbr" />
        <TextInput label="Logo URL" source="logoUrl" />
        <TextInput label="Stable ID" source="stableId" />
      </SimpleForm>
    </Edit>
  );
};

export default SchoolEdit;
